import { userState } from "src/state/state";
import { factoryCampaignInstances } from "./SignupCustomCampaignGenericInstances";
import type FactorySignupCustomCampaign from "./FactorySignupCustomCampaign";

/**
 * Find a campaign whose `employerProfileAttributeId` matches the backend-
 * assigned `partner.employers.current` profile attribute on the current
 * user's account (`userState.isEmployerMember`). This is the authoritative
 * employer signal, and the only one available for members whose eligibility
 * questionnaire never asks/answers the employer question — e.g. a Bank of
 * New York member reached via Transcarent SSO, whose employer is assigned
 * directly on their account rather than self-reported in the questionnaire.
 */
export function findMatchingCampaignByEmployerAttribute(): FactorySignupCustomCampaign | null {
  for (const campaign of factoryCampaignInstances()) {
    const employerId = campaign.factoryOptions.employerProfileAttributeId;

    if (employerId && userState.isEmployerMember(employerId)) {
      return campaign;
    }
  }

  return null;
}
